/**
 * Styled Components - Created by miguelcanobbio on 25/07/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import Tooltip from 'antd/lib/tooltip'
import { BLACK, BLUE, GRAY_DARK, ORANGE_STATUS, RED, WHITE } from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'

type Props = {
  color?: string
}

export const Container = styled.div`
  padding-bottom 80px;
`

export const ToolTipDiv = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  margin-top: -12px;
  margin-bottom: 22px;
  color: ${BLUE};
  animation: fade-in-right 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(12px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media(max-width: 698px) {
    display: flex;
  }
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
`

export const PopoverText = styled.div`
  font-size: 14px;
  color: ${BLACK};
  font-family: Avenir;
  a {
    color: ${BLUE};
  }
`

export const InfoIcon = styled(Icon)`
  display: inline-flex;
  margin-right: 8px;
  font-size: 12px;
`

export const InfoIconPalette = styled(Icon)`
  display: inline-flex;
  margin-left: 14px;
  font-size: 16px;
  color: ${BLUE};
  vertical-align: top;
  margin-top: 2px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 698px) {
    font-size: 18px;
  }
`

export const DeliveryLabels = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 16px;
  font-size: 13px;
  @media (max-width: 480px) {
    flex-flow: row;
    align-items: center;
  }
`

export const Message = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin-bottom: 36px;
  @media (max-width: 698px) {
    display: none;
  }
`

export const Subtitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
`

export const VerticalDivider = styled.div`
  widht: 100%;
  height: 1px;
  background-color: #dcdcdc;
  margin: 24px 0;
`

export const ModalMessage = styled.div`
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`

export const DraggerBottom = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 48px;
  .ant-upload.ant-upload-drag {
    background: ${WHITE};
    padding: 8px 22px;
  }
  @media (max-width: 768px) {
    flex-flow: column;
    margin-bottom: 0px;
  }
`

export const StyledAlertMessage = styled.div`
  display: flex;
  position: absolute;
  left: 12px;
  z-index: 2;
  top: -32px;
  text-align: left;
  max-width: 388px;
  background: black;
  border-radius: 3px;
  padding: 2px 6px;
  color: white;
  display: none;
  align-items: center;
  animation: fade-in-right-alert 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right-alert {
    0% {
    transform: translateX(-10px);
      opacity: 0;
    }
    100% {
    transform: translateX(0);
      opacity: 1;
    }
  }
`

export const AlertIcon = styled(Icon)`
  color: red;
  margin-right: 10px;
`

export const Recommendation = styled.div`
  color: ${({ color = GRAY_DARK }: Props) => color};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 23px;
  padding: 8px 34px;

  @media (min-width: 768px) and (max-width: 991px) {
    padding: 8px 10px;
  }
  @media (max-width: 768px) {
    padding: 8px 0;
  }
`

export const RecommendationSection = styled.div`
  max-width: 420px;
  width: 100%;
  @media (max-width: 698px) {
    display: none;
  }
`

export const ModalTitleStyled = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`

export const SizeTitle = styled.div`
  color: ${RED};
  text-align: center;
  font-weight: bold;
`

export const SizeBody = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 24px 0 12px -38px;
`

export const DPIWarning = styled.div`
  margin-top: 24px;
  color: ${ORANGE_STATUS};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const WarningDPI = styled(Icon)`
  margin-right: 12px;
  color: ${ORANGE_STATUS};
`

export const DPIText = styled.div``

export const WarningIcon = styled(Icon)``

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const DescriptionSection = styled.div`
  margin-left: 32px;
  font-family: Avenir;
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 20px;
  }
`

export const InfoImage = styled.img`
  width: calc(100% + 32px);
  max-width: 428px;
  margin-left: 8px;
  margin-bottom: 0px;
  @media (max-width: 698px) {
    margin-left: -12px;
    margin-bottom: -10px;
  }
`

export const ModalTitlePalette = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const ModalTitlePractices = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
`

export const PreviewRight = styled.div`
  margin: -12px -6px 16px -42px;
`

export const ImageContent = styled.div`
  width: 100%;
  text-align: center;
`

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 179px;
  margin: 0 auto;
  display: inline-block;
  margin-bottom: 14px;
  border-radius: 3px;
  margin-top: -12px;
`

export const LogoImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: contain;
  font-size: 24px;
  color: ${GRAY_DARK};
  background: #F1F4F5;
  margin: 0 auto;
  padding: 64px;
`

export const PDFPreview = styled.embed`
  margin-bottom: 14px;
  box-shadow: 1px 1px 4px 1px lightgrey;
`

export const TermsLabel = styled.div``

export const EditContent = styled.div`
  color: ${RED};
  margin-bottom: 4px;
`

export const TermsLink = styled.div`
  color: ${BLUE};
  margin-left: 4px;
  margin-right: 4px;
  display: inline-flex;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const TitleTerms = styled.div`
  font-weight: bold;
  margin-top: 22px;
  font-size: 16px;
  text-align: center;
`

export const TooltipContentModal = styled.div`
  margin-left: -22px;
  width: 100%;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  margin-bottom: 12px;
  max-height: 448px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .3);
  }
  .highlight {
    color: red;
    font-style: italic;
  }

  b {
    font-weight: 700;
  }
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const ErrorContent = styled.div`
  margin-left: -36px;
  width: calc(100% + 36px);
`

export const ErrorBody = styled.div`
  ul {
    padding-left: 16px;
    margin-top: -6px;
  }
`

export const ErrorTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
`

export const ErrorFileName = styled.div`
  margin-bottom: 12px;
  color: #e34b62;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const BrokenImage = styled.img`
  max-width: 22px;
  margin-right: 8px;
`

export const closeButtonStyle = {
  position: 'absolute',
  right: '-6px',
  top: '-6px',
  color: '#393939',
  border: '1px solid #2d2d2d',
  borderRadius: '25px',
  width: '24px',
  height: '24px',
  background: 'white',
  fontSize: '12px',
  padding: '0',
  lineHeight: 'unset'
}

export const errorButtonStyle = {
  color: '#3979c3',
  background: WHITE,
  borderColor: '#4A90E2',
  textShadow: 'none'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyFiles/styledComponents.tsx